<template>

    <div id="homeBox">
        <div class="flexcenter" id="flexcenter">
            <el-button type="text" style="height: 2.5rem"  icon="el-icon-plus"  @click="add">新增</el-button>

            <div style="margin-right: 20px">
                <el-input
                        size="mini"
                        style="width: 200px  "

                        placeholder="请输入搜索内容"
                        v-model="Searchdata"
                        clearable>
                </el-input>
                <el-button  class="mrl15 " icon="el-icon-search" circle  @click="Searchbusy" size="mini"></el-button>
            </div>
        </div>
        <el-table
                id="eltable"

                ref="deliverlight"
                :height="tableHeight"
                highlight-current-row
                size="mini"
                :data="tableData"
                border
                style="width: 100%">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')"
                    width="50"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="bmName"
                    label="部门"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="cjName"
                    label="车间"

                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="type"
                    label="轮班类型"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="taskType"
                    label="任务类型"

                    show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span v-if="scope.row.taskType==1">生产</span>
                    <span v-if="scope.row.taskType==2">安全</span>
                    <span v-if="scope.row.taskType==3">环保</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="pubType"
                    label="发布途径"

                    show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span v-if="scope.row.pubType==1">接班</span>
                    <span v-if="scope.row.pubType==2">定时</span>

                </template>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="是否重复"

                    show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span v-if="scope.row.isRepeat==0">否</span>
                    <span v-if="scope.row.isRepeat==1">是</span>
<!--                    <span v-if="scope.row.isRepeat=='Month'">每月</span>-->

                </template>
            </el-table-column>
            <el-table-column
                    prop="stationName"
                    label="岗位"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="templateName"
                    label="模板"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="information"
                    label="信息点"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="position"
                    label="坐标位置"
                    width="100"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column

                    label="是否NFC"
                    width="80"

                    show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.isNfc==1?'是':'否'}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="nfc"
                    label="NFC"
                    width="70"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="nfcReal"
                    label="实际NFC"
                    width="70"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="photo"
                    label="照片数量"
                    width="70"

                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="video"
                    label="视频时长(s)"
                    width="90"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="cycle"
                    label="任务周期"
width="70"
                    show-overflow-tooltip>
                <template slot-scope="scope" >
                    <span v-if="scope.row.cycle=='Day'">每日</span>
                    <span v-if="scope.row.cycle=='Week'">每周</span>
                    <span v-if="scope.row.cycle=='Month'">每月</span>

                </template>
            </el-table-column>

            <el-table-column
                    label="开始时间"
                    show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <span v-if="scope.row.beginTime==''">无</span>
                                    <span v-if="scope.row.beginTime!==''">{{scope.row.beginTimeText}}</span>
                                </template>
            </el-table-column>
            <el-table-column
                    label="结束时间"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.endTime==''">无</span>
                    <span v-if="scope.row.endTime!==''">{{scope.row.endTimeText}}</span>
                </template>
            </el-table-column>
            <el-table-column
        prop="duration"
                    label="时长(h) "
        width="70"
                    show-overflow-tooltip>
<!--                <template slot-scope="scope">-->
<!--                    <span v-if="scope.row.isOver==1">是</span>-->
<!--                    <span v-if="scope.row.isOver==0">否</span>-->
<!--                </template>-->
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="rate"-->
<!--                    label="频率"-->

<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
            <!--                <el-table-column-->

            <!--                        label="是否继续"-->

            <!--                        show-overflow-tooltip>-->
            <!--                    <template slot-scope="scope">-->
            <!--                        <span v-if="scope.row.isNext==1">是</span>-->
            <!--                        <span v-if="scope.row.isNext==0">否</span>-->
            <!--                    </template>-->
            <!--                </el-table-column>-->
<!--            <el-table-column-->
<!--                    prop="describe"-->
<!--                    label="录入人"-->

<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->

            <el-table-column

                    label="状态"
                    width="60"
                    show-oveflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.state==1">启用</span>
                    <span v-if="scope.row.state==0">未启用</span>
                    <span v-if="scope.row.state==-1">{{$t('button_nullify')}}</span>
<!--                    <span v-else>禁用</span>-->
                </template>
            </el-table-column>
            <el-table-column
                    prop="lruName"
                    label="录入人"
                    width="60"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="录入时间"

                    show-overflow-tooltip>
            </el-table-column>
<!--                            <el-table-column-->
<!--                                    width="100"-->
<!--                                    label="操作">-->
<!--                                <template slot-scope="scope">-->


<!--                                    <div>{{scope.row.state==1?'启用':'已失效'}}</div>-->
<!--                                </template>-->
<!--                            </el-table-column>-->
            <el-table-column
                    width="130"
                    label="操作">
                <template slot-scope="scope" >
                    <div >
                        <el-button  type="text" size="mini" @click="copy(scope.row)">复制</el-button>

                        <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
                        <el-button style="color:red;"  type="text" size="mini" @click="del(scope.row)">{{$t('button_nullify')}}</el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother  fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"

                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :pager-count="5"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">

                    </el-pagination>
                </div>

            </div>
        </div>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                top="350px"
                width="520px"
                height="300"
                :title="title"
                :visible.sync="bianjipingtai"
                v-if="bianjipingtai"
        >
            <revise-task  @getTasksList="getTasksList" :editData="editData" @close="close"></revise-task>
        </el-dialog>
        <el-dialog
                :close-on-click-modal="false"
                style="display: flex;justify-content: center;align-items: center;color: black;font-weight: bold"
                title="提示"
                :visible.sync="delDialogVisible"
                width="400px"
                top="30px"
                height="300"
                center
                v-if="delDialogVisible"
        >
            <div style="display:flex;justify-content: center;align-items: center;margin: 15px 0">{{deltitle}}</div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="delDialogVisible = false">{{$t('button_cancel')}}</el-button>
    <el-button type="primary" @click="submitdel">确 定</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
    import {baseerp} from "@/utils/baseUrl";
    import * as API from "./api";
    import {mapActions} from "vuex";
    import reviseTask from "./component/reviseTask";

    export default{
        name:'TaskSet',
        components:{
            reviseTask,

        },

        data(){
            return{
                rwtype:[{
                    id:2,
                    value:'轮班'
                },{
                    id:1,
                    value:'固定'
                }],
                deltitle:'',
                editData:{},
                ceshidata:[],
                gwdata:[{
                    id:1,
                    value:'厂长'
                },{
                    id:2,
                    value:'班长'
                },{
                    id:3,
                    value:'卸料'
                },{
                    id:4,
                    value:'成盐'
                },{
                    id:5,
                    value:'缩合'
                },{
                    id:6,
                    value:'浓缩'
                },{
                    id:7,
                    value:'中控'
                },{
                    id:8,
                    value:'小组长'
                },{
                    id:9,
                    value:'商水班长'
                },{
                    id:10,
                    value:'商水叉车'
                },{
                    id:11,
                    value:'商水操作工'
                },],
                bianjipingtai:false,//编辑弹框
                Searchdata:'',//搜索内容
                currentPage:1,
                pageSize:10,
                total:0,
                baseerp:'',
                tableData: [],
                tableHeight:0,//列表高度
                consumername:[],//消费名字数据
                title:'',
                delDialogVisible:false//删除弹框
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.$nextTick(()=>{
                this.onResize();

            })

            //公共样式
            this.baseerp=baseerp
            this.getTasksList()
            // this.$nextTick(function () {
            //     this.heightAuto();
            // window.addEventListener('resize',this.onResize);

            // });

        },

        beforeDestroy() {
            // window.removeEventListener('resize',this.heightAuto)
        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            //高度

            heightAuto(){
                // this.$nextTick(()=>{
                //     document.getElementById('body').getBoundingClientRect().top
                // })
                this.tableHeight = window.innerHeight - document.getElementById('body').getBoundingClientRect().top -48 -36    ;

                // console.log(this.tableHeight)
                // console.log(document.getElementById('body').getBoundingClientRect().top)
                // console.log(window.innerHeight)
                // console.log()
            },


            //关闭弹框
            close(){
                this.bianjipingtai=false
            },
            //页面搜索
            Searchbusy(){
                this.getTasksList()
                this.currentPage=1
            },
            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.getTasksList()
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPage = val;    //动态改变
                this.getTasksList()
            },
            async getStationsList(val) {
                // console.log(this.editData.bmName)
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:val,
                    // pid:this.editData.bmName
                    // isNext:this.editData.isNext
                }
                // console.log(params)
                // return
                let res = await API.getStationsList(params);
                if (res.code == 1) {
                    this.ceshidata=res.stationsList

                    // console.log(this.gwdata)
                    // if(this.editData.cjName!==''){
                    //     this.getTeamsList()
                    //
                    // }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //新增
            copy(e){
                this.title='复制新增'
                this.editData=Object.assign({},e);
                this.rwtype.filter(item=>{
                    if(item.value==this.editData.type){
                        this.editData.type=item.id
                    }
                })
                this.editData.id=0
                this.editData.nfc=''
                this.editData.nfcReal=''
                this.editData.position=''
                this.bianjipingtai=true

                // console.log(e)
            },
            add(){

                this.title='新增'
                this.editData={
                    id:0,
                    bmName:'',
                    cjName:'',
                    bzName:'',
                    templateName:'',
                    information:'',
                    localtionType:'',
                    position:'',
                    photo:0,
                    taskType:1,
                    pubType:1,
                    isNfc:1,
                    video:0,
                    cycle:'',
                    beginTime:'',
                    duration:'',
                    creatTime:'',
                    rate:'a',
                    lruid:parseFloat(sessionStorage.getItem("userid")) ,
                    lruName:sessionStorage.getItem('lruname'),
                    state:1,
                    type:2,
                    isRepeat:1,
                    endTime:''
                }
                this.bianjipingtai=true
            },
            //编辑
            edit(val){

                this.title='编辑'
                this.editData.id=val.id

                this.editData=Object.assign({},val);

                this.bianjipingtai=true
                // this.editData.type
                this.rwtype.forEach(item=>{
                    if(item.value==this.editData.type){
                        this.editData.type=item.id
                    }
                })
                // this.getServiceConfigDetail()

            },
            //确认作废
            submitdel(){
                this.voidTask()
                // console.log(this.editData)
                this.delDialogVisible=false
            },
//作废
            del(val){
                this.title='删除'
                this.editData=val
                this.taskUsed()
                this.delDialogVisible=true
                // console.log(this.editData)
                // console.log(this.editData.id)
            },

            //业务配置列表查询
            async getTasksList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    search:this.Searchdata,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }
                let res = await API.getTasksList(params);
                if (res.code == 1) {
                    this.tableData=res.tasksList
                    this.tableData.forEach(item=>{

                        this.rwtype.filter(val=>{
                            if(item.type==val.id){
                                item.type=val.value
                            }
                        })
                    })
                    // this.getStationsList()
                    this.total=res.total
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //业务配置作废
            async voidTask() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {

                    id:this.editData.id
                }
                let res = await API.voidTask(params);
                if (res.code == 1) {

                    this.getTasksList()
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.$message.error(res.message);
                }
            },
            //业务配置作废
            async taskUsed() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {

                    id:this.editData.id
                }
                let res = await API.taskUsed(params);
                if (res.code == 1) {
                   this.deltitle='是否确定要删除'

                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);

                } else {
                    this.deltitle=res.message
                    // this.$message.error(res.message);
                }
            },


        },

    }
</script>
<style lang="scss" scoped>
    .flexcenter{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
    /deep/{
        .el-table--enable-row-transition{
            /*min-width: 53.571rem !important;*/
        }
        .el-button--text{
            padding: 0 !important;
            margin-left: 0 !important;
            margin-right: 10px;
        }
        .el-tabs__content{
            /*height: 90% !important;*/
            overflow: visible !important;
            height:calc(100% - 0.357rem) !important;
        }
    }
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
    .input{
        width: 14.286rem;
    }
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 42.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }
</style>